import type { ReactNode } from "react";

import { classNames } from "@/utils/styling-utils";
import { HorizontalSpacer } from "../../layout/horizontal-spacer";
import { Text } from "../../ui/text";
import type { InputBaseProps } from "./input.model";

interface InputErrorMessageProps {
  errorMessage?: string;
  externalErrorMessage?: string | ReactNode;
  size?: InputBaseProps["size"];
}

export const InputErrorMessage = ({ errorMessage, externalErrorMessage, size }: InputErrorMessageProps) => {
  if (!(errorMessage || externalErrorMessage)) {
    return <></>;
  }

  return (
    <div className={classNames("input-error-message", size === "small" && "input-error-message__size--small")}>
      {/* Viser én feilmelding om gangen */}
      {errorMessage ? (
        <>
          <HorizontalSpacer size="xx-small" />
          <Text color="red" size="small" style="italic" value={errorMessage} />
        </>
      ) : (
        externalErrorMessage && (
          <>
            <HorizontalSpacer size="xx-small" />
            {typeof externalErrorMessage === "string" ? (
              <Text color="red" size="small" style="italic" value={externalErrorMessage} />
            ) : (
              externalErrorMessage
            )}
          </>
        )
      )}
    </div>
  );
};
